export default __webpack_public_path__ + "static/media/icon_image_links.ca2752c9.svg";